function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingPlans3 = function SvgLandingPlans3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18202_16767)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 24,
    fill: "#3EC0FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18202_16767)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 30C44 37.732 37.732 44 30 44C22.268 44 16 37.732 16 30C16 22.268 22.268 16 30 16C37.732 16 44 22.268 44 30ZM30.5017 26.3354C29.14 26.9018 26.4185 28.0741 22.3372 29.8522C21.6745 30.1158 21.3273 30.3736 21.2957 30.6257C21.2423 31.0517 21.7758 31.2195 22.5024 31.448C22.6012 31.4791 22.7036 31.5113 22.8086 31.5454C23.5234 31.7777 24.485 32.0496 24.9848 32.0604C25.4383 32.0702 25.9443 31.8832 26.5031 31.4996C30.3164 28.9255 32.2848 27.6244 32.4084 27.5964C32.4955 27.5766 32.6164 27.5517 32.6982 27.6245C32.7801 27.6972 32.772 27.835 32.7634 27.872C32.7105 28.0973 30.6161 30.0444 29.5323 31.0521C29.1944 31.3662 28.9548 31.589 28.9058 31.6399C28.796 31.7539 28.6841 31.8617 28.5766 31.9654C27.9126 32.6055 27.4146 33.0856 28.6042 33.8696C29.1759 34.2463 29.6334 34.5579 30.0898 34.8687C30.5882 35.2081 31.0853 35.5466 31.7285 35.9683C31.8924 36.0757 32.0489 36.1873 32.2014 36.2959C32.7814 36.7095 33.3025 37.081 33.9464 37.0217C34.3204 36.9873 34.7069 36.6355 34.9031 35.5864C35.3669 33.107 36.2786 27.7349 36.4893 25.5211C36.5077 25.3272 36.4845 25.079 36.4658 24.97C36.4472 24.861 36.4082 24.7058 36.2666 24.5909C36.0989 24.4548 35.8399 24.4261 35.7241 24.4281C35.1975 24.4374 34.3896 24.7183 30.5017 26.3354Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter0_dii_18202_16767)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.289062,
    width: 62.7024,
    height: 62.0133,
    rx: 24,
    transform: "rotate(-0.27563 0 0.289062)",
    fill: "url(#paint0_linear_18202_16767)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_18202_16767",
    x: -4.42874,
    y: -3.7916,
    width: 78.9949,
    height: 76.3609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.54202,
    dy: 3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18202_16767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_18202_16767",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.54202,
    dy: 3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_18202_16767"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.54202,
    dy: -3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_18202_16767",
    result: "effect3_innerShadow_18202_16767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18202_16767",
    x1: 10.8965,
    y1: 7.85166,
    x2: 52.6412,
    y2: 53.4981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18202_16767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18202_16767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  }))));
};
export default SvgLandingPlans3;